import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export default function Discord(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M20.33,4.42c-0.01-0.01-0.02-0.02-0.03-0.03c-1.55-0.71-3.19-1.22-4.87-1.51c-0.03-0.01-0.06,0.01-0.08,0.04
			c-0.22,0.4-0.43,0.82-0.61,1.25c-1.81-0.28-3.66-0.28-5.47,0C9.08,3.74,8.88,3.32,8.65,2.92C8.63,2.89,8.6,2.88,8.57,2.88
			C6.89,3.17,5.25,3.68,3.7,4.39C3.68,4.4,3.67,4.41,3.67,4.42c-3.1,4.63-3.95,9.16-3.54,13.62c0,0.02,0.01,0.04,0.03,0.06
			c1.81,1.34,3.83,2.36,5.98,3.02c0.03,0.01,0.06,0,0.08-0.03c0.46-0.63,0.87-1.29,1.22-1.99c0.01-0.02,0.01-0.04,0-0.06
			C7.44,19.02,7.42,19,7.4,19c-0.65-0.25-1.27-0.54-1.87-0.89c-0.02-0.01-0.04-0.04-0.04-0.06c0-0.03,0.01-0.05,0.03-0.07
			c0.13-0.09,0.25-0.19,0.37-0.29c0.02-0.02,0.05-0.02,0.08-0.01c3.92,1.79,8.16,1.79,12.03,0c0.03-0.01,0.06-0.01,0.08,0.01
			c0.12,0.1,0.25,0.2,0.37,0.29c0.02,0.02,0.03,0.04,0.03,0.07c0,0.03-0.02,0.05-0.04,0.06c-0.6,0.35-1.22,0.65-1.87,0.89
			c-0.02,0.01-0.04,0.02-0.04,0.04c-0.01,0.02-0.01,0.04,0,0.06c0.36,0.69,0.77,1.36,1.22,1.99c0.02,0.03,0.05,0.04,0.08,0.03
			c2.15-0.66,4.18-1.68,5.99-3.02c0.02-0.01,0.03-0.03,0.03-0.06C24.37,12.88,23.03,8.4,20.33,4.42L20.33,4.42z M8.03,15.32
			c-1.18,0-2.15-1.08-2.15-2.41c0-1.33,0.95-2.41,2.15-2.41c1.21,0,2.17,1.09,2.15,2.41C10.18,14.24,9.23,15.32,8.03,15.32
			L8.03,15.32z M15.98,15.32c-1.18,0-2.15-1.08-2.15-2.41c0-1.33,0.95-2.41,2.15-2.41c1.21,0,2.17,1.09,2.15,2.41
			C18.14,14.24,17.19,15.32,15.98,15.32L15.98,15.32z M15.98,15.32"
      />
    </SvgIcon>
  )
}
